import React from 'react';
import ArticleCardComponent from './ArticleCardComponent';
import { markdownToHtml } from '../utils/commonFunctions';

const BotResponseComponent = ({ response }) => {
  const { saludo, articulos, recomendacion } = response;

  return (
    <div className="bot-response">
      {saludo && (
        <div className="bot-greeting mb-3">
          <span dangerouslySetInnerHTML={{ __html: markdownToHtml(saludo) }}></span>
        </div>
      )}

      {articulos && articulos.length > 0 && (
        <div className="bot-articles my-3">
          {articulos.map((articulo, index) => (
            <ArticleCardComponent key={index} articulo={articulo} />
          ))}
        </div>
      )}

      {recomendacion && (
        <div className="bot-recommendation mt-3">
          <span dangerouslySetInnerHTML={{ __html: markdownToHtml(recomendacion) }}></span>
        </div>
      )}
    </div>
  );
};

export default BotResponseComponent;
